import React from 'react'
import {Box} from '@mui/material'
import {GatewayCardModel} from './types'
import GatewayCard from './GatewayCard'
import GatewayCardSkeleton from './GatewayCardSkeleton'

type Props = {
  cards: GatewayCardModel[]
  isLoading?: boolean
  metricsLoading?: boolean
  busyFactory?: string | null
  onConnect: (card: GatewayCardModel) => void
  onManage: (card: GatewayCardModel) => void
  onDelete: (card: GatewayCardModel) => void
}

export default function GatewayGrid({
  cards,
  isLoading,
  metricsLoading,
  busyFactory,
  onConnect,
  onManage,
  onDelete,
}: Props) {
  return (
    <Box
      sx={{
        display: 'grid',
        gap: {xs: '12px', sm: '16px', lg: '24px'},
        gridTemplateColumns: {
          xs: '1fr',
          sm: 'repeat(2, minmax(0, 1fr))',
          lg: 'repeat(3, minmax(0, 1fr))',
        },
      }}
    >
      {isLoading
        ? [0, 1, 2].map((key) => (
            <Box
              key={key}
              sx={{
                display: {xs: key > 0 ? 'none' : 'block', sm: key > 1 ? 'none' : 'block', lg: 'block'},
              }}
            >
              <GatewayCardSkeleton />
            </Box>
          ))
        : cards.map((card) => (
            <GatewayCard
              key={card.factory_name}
              card={card}
              metricsLoading={metricsLoading}
              busy={busyFactory === card.factory_name}
              onConnect={onConnect}
              onManage={onManage}
              onDelete={onDelete}
            />
          ))}
    </Box>
  )
}
